import Payment from "./Payment";
import BookingFinanceDocument from "./BookingFinanceDocument";
import ExtraCharges from "./ExtraCharges";
import TouristTaxRecord from "./TouristTaxRecord";

export default class BookingFinance {

    constructor(apiResponse) {
        this.id = apiResponse.id;
        this.bookingId = apiResponse.bookingId;
        this.totalPrice = apiResponse.totalPrice ? Number.parseFloat(apiResponse.totalPrice) : null;
        this.totalPayed = apiResponse.totalPayed ? Number.parseFloat(apiResponse.totalPayed) : null;
        this.balance = apiResponse.balance ? Number.parseFloat(apiResponse.balance) : null;
        this.deposit = apiResponse.deposit ? Number.parseFloat(apiResponse.deposit) : null;
        this.discount = apiResponse.discount ? Number.parseFloat(apiResponse.discount) : null;
        this.touristTax = apiResponse.touristTax ? Number.parseFloat(apiResponse.touristTax) : null;
        this.securityDeposit = apiResponse.securityDeposit ? Number.parseFloat(apiResponse.securityDeposit) : null;
        this.isTouristTaxProvidedByHost = apiResponse.isTouristTaxProvidedByHost ?? false;

        this.payments = apiResponse.payments ? apiResponse.payments.map(p => new Payment(p)).sort((a, b) => a.date - b.date) : [];
        this.extraCharges = apiResponse.extraCharges ? apiResponse.extraCharges.map(ec => new ExtraCharges(ec)) : [];
        this.touristTaxRecords = apiResponse.touristTaxRecords ? apiResponse.touristTaxRecords.map(ttr => new TouristTaxRecord(ttr)) : [];
        this.bookingFinanceDocument = apiResponse.bookingFinanceDocument ? new BookingFinanceDocument(apiResponse.bookingFinanceDocument) : null;
    }

    clone() {
        const bookingFinance = new BookingFinance({});
        bookingFinance.id = this.id;
        bookingFinance.bookingId = this.bookingId;
        bookingFinance.totalPrice = this.totalPrice;
        bookingFinance.totalPayed = this.totalPayed;
        bookingFinance.balance = this.balance;
        bookingFinance.deposit = this.deposit;
        bookingFinance.discount = this.discount;
        bookingFinance.touristTax = this.touristTax;
        bookingFinance.securityDeposit = this.securityDeposit;
        bookingFinance.isTouristTaxProvidedByHost = this.isTouristTaxProvidedByHost;

        bookingFinance.payments = this.payments.map(p => p.clone());
        bookingFinance.extraCharges = this.extraCharges.map(ec => ec.clone());
        bookingFinance.touristTaxRecords = this.touristTaxRecords.map(ttr => ttr.clone());

        bookingFinance.bookingFinanceDocument = this.bookingFinanceDocument ? this.bookingFinanceDocument.clone() : null;

        return bookingFinance;
    }

    addPayment(paymentApiResponse){
        this.payments = [...this.payments, new Payment(paymentApiResponse)];
        this.totalPayed = this.payments.reduce((sum, p) => sum + (p.amount ?? 0), 0);
        this.balance = this.totalPrice - this.totalPayed;
        if(this.bookingFinanceDocument) {
            this.bookingFinanceDocument.hasOldData = true;
        }
    }

    removePayment(paymentId){
        this.payments = this.payments.filter(p => p.id !== paymentId);
        this.totalPayed = this.payments.reduce((sum, p) => sum + (p.amount ?? 0), 0);
        this.balance = this.totalPrice - this.totalPayed;
        if(this.bookingFinanceDocument) {
            this.bookingFinanceDocument.hasOldData = true;
        }
    }
}